<div class="container-fluid p-0">
  <div class="card rounded-0">
    <div class="card-body">
      <div class="row">
        <div class="col-12">
          <h6 class="mb-3">Noticeboard</h6>
          @if(site.induction_content) {
            <div [innerHTML]="site.induction_content | sanitizeHtml"></div>
          } @else {
            <p>No noticeboard content available.</p>
          }
        </div>
      </div>
    </div>
  </div>
</div>
